<template>
  <div class="cvs" :class="{ 'is-selected': orden > 0 }">
    <button
      type="button"
      class="cvs-img"
      :aria-pressed="orden > 0"
      :aria-label="(orden > 0 ? 'Quitar ' : 'Seleccionar ') + imageSrc"
      @click="$emit('selectedImage', { url: imageSrc, isSelected: orden > 0 })"
    >
      <img :src="src" :alt="imageDescription || ''" loading="lazy" @error="usarGrande" />
      <span class="cvs-check">
        <template v-if="orden > 0 && multiSelect">{{ orden }}</template>
        <span v-else class="material-symbols-outlined">check</span>
      </span>
    </button>
    <button
      v-if="puedeEliminar"
      type="button"
      class="cvs-delete"
      title="Eliminar imagen"
      aria-label="Eliminar imagen"
      @click="$emit('eliminarImagen', { src: imageSrc, index: imageId })"
    >
      <span class="material-symbols-outlined">delete</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "cardViewSelector",
  props: {
    imageSrc: String,
    imageId: [String, Number],
    imageDescription: String,
    // Posición en la selección (0 = no seleccionada)
    orden: { type: Number, default: 0 },
    multiSelect: Boolean,
    puedeEliminar: { type: Boolean, default: true },
  },
  data() {
    return {
      base: this.$media,
      sinMiniatura: false,
    };
  },
  computed: {
    // Si falta la miniatura (minGallery) se muestra la imagen grande (gallery)
    src() {
      return `${this.base}/img/${this.sinMiniatura ? "gallery" : "minGallery"}/${this.imageSrc}`;
    },
  },
  watch: {
    imageSrc() {
      this.sinMiniatura = false;
    },
  },
  methods: {
    usarGrande() {
      if (!this.sinMiniatura) this.sinMiniatura = true;
    },
  },
};
</script>

<style scoped>
.cvs {
  position: relative;
}

.cvs-img {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  padding: 0;
  overflow: hidden;
  border: 2px solid transparent;
  border-radius: 12px;
  background: var(--sd-surface-2);
  cursor: pointer;
  transition: border-color 0.15s, transform 0.15s;
}

.cvs-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.cvs-img:hover img {
  transform: scale(1.05);
}

.cvs.is-selected .cvs-img {
  border-color: var(--sd-primary);
  box-shadow: 0 0 0 3px var(--sd-primary-soft);
}

.cvs.is-selected .cvs-img img {
  transform: scale(0.94);
  border-radius: 8px;
}

.cvs-check {
  position: absolute;
  top: 8px;
  left: 8px;
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  transition: background 0.15s;
}

.cvs-check .material-symbols-outlined {
  font-size: 16px;
  opacity: 0;
}

.cvs.is-selected .cvs-check {
  border-color: var(--sd-primary);
  background: var(--sd-primary);
  color: var(--sd-primary-contrast);
}

.cvs.is-selected .cvs-check .material-symbols-outlined {
  opacity: 1;
}

.cvs-delete {
  position: absolute;
  top: 8px;
  right: 8px;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--sd-danger);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s;
}

.cvs:hover .cvs-delete,
.cvs-delete:focus-visible {
  opacity: 1;
}

@media (hover: none) {
  .cvs-delete {
    opacity: 1;
  }
}

.cvs-delete .material-symbols-outlined {
  font-size: 18px;
}
</style>
